import React, { useEffect, useRef, useState } from "react";
import "../css/orders.css";
import { Page, Card } from "@shopify/polaris";

import { UploadCSV } from "./Orders/UploadCSV";
import { UploadCSVWoo } from "./Orders/UploadCSVWoo";
import OrderTable from "./Orders/OrderTable";
import config from "../config/config";
import BannerWoo from "./Dashboard/BannerWoo";
import { useDispatch, useSelector } from "react-redux";
import { actFetchFilter } from "../actions/index";
import { initialState } from "../reducers/filterIndicator";
import BannerHeader from "./Dashboard/BannerHeader";
import { UploadTrackingNumber } from "./Orders/UploadTrackingNumber";

const Orders = () => {
	const [listOrders, setListOrders] = useState([]);
	const { filterIndicator } = useSelector((state) => state);
	const dispatch = useDispatch();
	const ref = useRef(null);

	const updateListOrder = (listOrders) => {
		setListOrders(listOrders);
	};

	const updateListOrderWoo = () => {
		setListOrders([]);
	};

	const handleScroll = (ref) => {
		ref.scrollIntoView({
			alignToTop: true,
			block: "start",
			inline: "nearest",
			behavior: "smooth",
		});
	};

	useEffect(() => {
		const action = setTimeout(() => {
			const { current } = ref;
			// console.log(current);
			if (current) {
				if (filterIndicator.type !== "init") {
					handleScroll(current);
				}
			}
		}, 250);
		return () => {
			clearTimeout(action);
			dispatch(actFetchFilter(initialState));
		};
	}, [filterIndicator.payment, filterIndicator.status]);

	// console.log("pageYoffset", window.pageYOffset)
	// console.log("scrollY", window.scrollY)

	return (
		<div className="app_orders_page">
			<div>
				<BannerWoo />
			</div>
			<div fullWidth="true">
				<Card sectioned title="Sync tracking number for old orders">
					<BannerHeader />
				</Card>
				<div
					className="mt-4"
					ref={ref}
					id="orderTable"
					style={{ position: "relative" }}
				>
					<Card sectioned title="List orders">
						<OrderTable listOrders={listOrders} />
					</Card>
				</div>
				{config.platform === "WOO_COMMERCE" ? (
					<UploadCSVWoo updateListOrderWoo={updateListOrderWoo} />
				) : (
					<UploadCSV updateListOrder={updateListOrder} />
				)}
				{config.platform !== "WOO_COMMERCE" ? (
					<UploadTrackingNumber updateListOrder={updateListOrder} />
				) : null}
			</div>
		</div>
	);
};
export default Orders;
